var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-placeholders',[_c('content-placeholders-heading',{attrs:{"img":true}}),_c('content-placeholders-text',{attrs:{"lines":3}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }